module.exports = __webpack_public_path__ + "static/apple-touch-icon-62f101af9825c70beacf7c3667c1d584.png";